export enum MaritalStatus {
  MARRIED = 'CASADO',
  DIVORCED = 'DIVORCIADO',
  SEPARATED = 'SEPARADO',
  SINGLE = 'SOLTEIRO',
  WIDOWED = 'VIUVO',

}
